import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { securityTOTP } from './reducer';
import { securityTOTPScreens } from '../../screens/SecurityTOTP/constants';

const initSecurityTOTPState = {
  currentScreen: '',
  screenOptions: {},
  mainSettings: null,
  TOTPSteps: {
    [securityTOTPScreens.MAIN]: {
      step: 1,
      checked: false,
    },
    [securityTOTPScreens.RESET_TFA]: {
      step: 1,
      checked: false,
    },
    [securityTOTPScreens.SCAN]: {
      step: 2,
      checked: false,
    },
    [securityTOTPScreens.SAVE]: {
      step: 3,
      checked: false,
    },
    [securityTOTPScreens.VERIFY]: {
      step: 4,
      checked: false,
    },
  },
  TOTPStepsOpened: false,
};

export const SecurityTOTPContext = createContext(initSecurityTOTPState);

export const SecurityTOTPProvider = ({ children }) => {
  const [state, dispatch] = useReducer(securityTOTP?.SecurityTOTPReducer, initSecurityTOTPState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in securityTOTP?.actions) {
    boundActions[key] = securityTOTP.actions[key](dispatch);
  }

  return (
    <SecurityTOTPContext.Provider value={{ state, ...boundActions }}>
      {children}
    </SecurityTOTPContext.Provider>
  );
};

SecurityTOTPProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
